import React from "react";

const Contact = () => {
  return (
    <>
    <h1>Contact Me ☏</h1>
    <p>Did you find something I lost? Please contact me at contact@lisechen.no :) Thank you BTW, I spend an embarassing amount of money replacing things I lose :(</p>
    </>
  )
};

export default Contact;
